import { useCallback, useState, type MouseEvent } from 'react';

export function useWindowsMt5Download() {
  const [showWindowsMt5Modal, setShowWindowsMt5Modal] = useState(false);
  const [checkingWindowsMt5Region] = useState(false);

  const closeWindowsMt5Modal = useCallback(() => {
    setShowWindowsMt5Modal(false);
  }, []);

  const handleWindowsMt5DownloadClick = useCallback((event?: MouseEvent<HTMLElement>) => {
    event?.preventDefault();

    if (typeof console !== 'undefined') {
      console.info('[JL金利寶] Windows MT5 download choice: always_show_choice');
    }

    setShowWindowsMt5Modal(true);
  }, []);

  return {
    showWindowsMt5Modal,
    checkingWindowsMt5Region,
    closeWindowsMt5Modal,
    handleWindowsMt5DownloadClick,
  };
}
